import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import LOCAL_STORAGE from "@/constants/local-storage";
import ROUTE_URLS from "@/constants/route-urls";
import { checkIfTokenIsExpired, decodeToken, validateImpersonationToken } from "@/helpers/auth-helpers";

import ImpersonationAccessScreen from "./components/ImpersonationAccessScreen";

export default function LoginImpersonation() {
  const { token, lang } = useParams<{ token: string; lang: string }>();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const handleImpersonationLogin = async () => {
      try {
        if (!token) {
          setError("Token ausente");
          return;
        }

        const decoded = decodeToken(token);

        if (checkIfTokenIsExpired(decoded)) {
          setError("Sua sessão expirou.");
          return;
        }

        validateImpersonationToken(decoded);

        localStorage.setItem(LOCAL_STORAGE.accessTokenKey, token);
        localStorage.setItem(LOCAL_STORAGE.refreshTokenKey, token);

        const targetLang = (lang as "PT-BR") || "PT-BR";
        window.location.replace(ROUTE_URLS.serviceDashboard(targetLang));
      } catch (err: unknown) {
        const message = err instanceof Error ? err.message : "Falha ao realizar login";
        setError(message);
        setIsLoading(false);
      }
    };

    handleImpersonationLogin();
  }, [token, lang]);

  if (isLoading) {
    return <ImpersonationAccessScreen mode="loading" />;
  }

  if (error) {
    return (
      <ImpersonationAccessScreen
        mode="error"
        message={error}
        onBack={() => navigate(ROUTE_URLS.login((lang as "PT-BR") || "PT-BR"))}
      />
    );
  }

  return null;
}
